module.exports = __webpack_public_path__ + "static/media/bg_fruit_fig_transparent.590ab844.png";